export const defaultCode = `def hello_world():
    return "Hello World! Welcome to Float16 Serverless GPU."

print(hello_world())
`;